import script from "./CompanyResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyResetPassword.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__